export enum mediaContentTypes {
  SITUATION = 'situation',
  PORTRAIT = 'portrait',
}
